var map = {
	"./de/news.json": [
		75019,
		431
	],
	"./de/page.companyReport.dividend.json": [
		26735,
		9687
	],
	"./de/page.companyReport.future.json": [
		11525,
		8534
	],
	"./de/page.companyReport.health.json": [
		32702,
		431
	],
	"./de/page.companyReport.json": [
		42723,
		8772
	],
	"./de/page.companyReport.overview.json": [
		71764,
		8875
	],
	"./de/statementGlossary.json": [
		76007,
		6007
	],
	"./de/web.json": [
		53343,
		3343
	],
	"./en/news.json": [
		90818,
		4895
	],
	"./en/page.companyReport.dividend.json": [
		54825,
		9687
	],
	"./en/page.companyReport.future.json": [
		44378,
		8534
	],
	"./en/page.companyReport.health.json": [
		7200,
		1666
	],
	"./en/page.companyReport.json": [
		51889,
		8772
	],
	"./en/page.companyReport.overview.json": [
		75912,
		8875
	],
	"./en/statementGlossary.json": [
		22479,
		2479
	],
	"./en/web.json": [
		75339,
		8117
	],
	"./es/news.json": [
		13574,
		8297
	],
	"./es/page.companyReport.dividend.json": [
		10117,
		9687
	],
	"./es/page.companyReport.future.json": [
		13223,
		8534
	],
	"./es/page.companyReport.health.json": [
		94804,
		1666
	],
	"./es/page.companyReport.json": [
		30186,
		8772
	],
	"./es/page.companyReport.overview.json": [
		89697,
		8875
	],
	"./es/statementGlossary.json": [
		6924,
		6924
	],
	"./es/web.json": [
		6476,
		6476
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36350;
module.exports = webpackAsyncContext;